export function createCommentData({ uuid, meetingItemId, body, video, meetingModeSessionId, clientSyncToken }) {
  const comment = new FormData();
  comment.append('uuid', uuid);
  comment.append('body', body);
  comment.append('workspaceItemId', meetingItemId);
  if (meetingModeSessionId) comment.append('meetingModeSessionId', meetingModeSessionId);
  if (clientSyncToken) comment.append('clientSyncToken', clientSyncToken);

  if (video) {
    comment.append('video[file]', video.file);
    comment.append('video[audio_only]', video.audioOnly);
  }
  return comment;
}

export function createWorkspaceCommentData({ uuid, body, meetingItem, user, video, meetingModeSessionId }) {
  const { id, avatar, first_name, last_name } = user;
  const comment = {
    uuid,
    body,
    type: 'workspaceComment',
    workspaceItemId: meetingItem.id,
    user: { id, avatar, firstName: first_name, lastName: last_name },
    createdAt: new Date().toISOString(),
    attachments: [],
    meetingModeSessionId,
  };

  if (video) {
    comment.video = {
      url: window.URL.createObjectURL(video.file),
      previewImageUrl: video.preview,
      audioOnly: video.audioOnly,
    };
  }

  return comment;
}

export function getUuidsToPositions(items) {
  return items.map(({ uuid, parentId: parentIdAttr }, index) => ({
    uuid,
    position: index + 1,
    parentId: parentIdAttr,
  }));
}
